import { render } from "./LoadingSpinner.vue?vue&type=template&id=33baaac8&scoped=true&ts=true"
import script from "./LoadingSpinner.vue?vue&type=script&lang=ts"
export * from "./LoadingSpinner.vue?vue&type=script&lang=ts"

import "./LoadingSpinner.vue?vue&type=style&index=0&id=33baaac8&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33baaac8"]])

export default __exports__